module.exports = __webpack_public_path__ + "media/img/illustrations/bot-face-a3786e6b2d0f18c0b70990f842418d5e.svg";